import { Action, PermissionCheckArgs, Process, System } from '@absg/angular-platform';
import { PurchaseOrderPermission } from 'shared.permissions/purchase-order.permission';

export abstract class InventoryManagementPermission {
  static dispenseInventory: PermissionCheckArgs = {
    action: Action.Dispense,
    process: Process.InventoryManagement,
    system: System.NucleusInventory,
  };
  static returnInventory: PermissionCheckArgs = {
    action: Action.Return,
    process: Process.InventoryManagement,
    system: System.NucleusInventory,
  };
  static wasteInventory: PermissionCheckArgs = {
    action: Action.Waste,
    process: Process.InventoryManagement,
    system: System.NucleusInventory,
  };
  static restockInventory: PermissionCheckArgs = {
    action: Action.Restock,
    process: Process.InventoryManagement,
    system: System.NucleusInventory,
  };
  static auditInventory: PermissionCheckArgs = {
    action: Action.Audit,
    process: Process.InventoryManagement,
    system: System.NucleusInventory,
  };
  static managePatientOwnedItemsOnly = {
    action: Action.ManagePatientOwnedItemsOnly,
    process: Process.InventoryManagement,
    system: System.NucleusInventory,
  };
  static transfersInventory: PermissionCheckArgs = {
    action: Action.Transfer,
    process: Process.InventoryManagement,
    system: System.NucleusInventory,
  };
  static cancelAnnexTransferRequest: PermissionCheckArgs = {
    action: Action.CancelAnnexTransferRequest,
    process: Process.InventoryManagement,
    system: System.NucleusInventory,
  };
  static positionManagement: PermissionCheckArgs = {
    action: Action.PositionManagement,
    process: Process.InventoryManagement,
    system: System.NucleusInventory,
  };
  static editWitnessRequired: PermissionCheckArgs = {
    action: Action.EditWitnessRequiredSetting,
    process: Process.InventoryManagement,
    system: System.NucleusInventory,
  };
  static witnessRequired: PermissionCheckArgs = {
    action: Action.Witness,
    process: Process.InventoryManagement,
    system: System.NucleusInventory,
  };
  static inventoryManagementPermissions = [
    InventoryManagementPermission.restockInventory,
    InventoryManagementPermission.positionManagement,
    InventoryManagementPermission.auditInventory,
    PurchaseOrderPermission.modification,
    PurchaseOrderPermission.approve,
    PurchaseOrderPermission.finalApprover,
    InventoryManagementPermission.dispenseInventory,
    InventoryManagementPermission.transfersInventory,
    InventoryManagementPermission.witnessRequired,
    InventoryManagementPermission.managePatientOwnedItemsOnly,
  ];

  static dispenseWasteReturnPermissions = [
    InventoryManagementPermission.dispenseInventory,
    InventoryManagementPermission.wasteInventory,
    InventoryManagementPermission.returnInventory,
  ];

}
